/** Namespaces i18n Karaté Phase 1 — structure FR/EN (contenus longs FR prioritaire). */
export const karateI18nNamespaces = {
  fr: {
    app: {
      login: "Connexion",
      logout: "Déconnexion",
      training: "Formation",
      help: "Aide",
      footerMeta: "Shotokan AAMC",
      switchRole: "Changer de profil via Connexion",
      placeholderFuture: "À venir en Phase 2+",
      translatePending: "[À traduire]",
      classes: "Classes / cours",
      courses: "Cours",
      schedule: "Horaires",
      events: "Événements",
      attendance: "Présences",
      present: "Présent",
      absent: "Absent",
      toConfirm: "À confirmer",
      notTracked: "Non suivi",
      lightAttendance: "Présences légères",
      progress: "Progression",
      belt: "Ceinture",
      grade: "Grade",
      exam: "Examen",
      technique: "Technique",
      kata: "Kata",
      kumite: "Kumite",
      discipline: "Discipline",
      admissible: "Admissible",
      recommended: "Recommandé",
      toPractice: "À pratiquer",
      mastered: "Maîtrisé",
      toReview: "À revoir",
      currentBelt: "Ceinture actuelle",
      nextBelt: "Prochaine ceinture",
      lightExams: "Examens légers",
      titles: "Titres",
      recognitions: "Reconnaissances",
      titleApplications: "Demandes de titres",
      titleAuthority: "Autorité d'attribution",
      appRole: "Rôle applicatif",
      underReview: "En révision",
      missingDocuments: "Documents manquants",
      approved: "Approuvé",
      refused: "Refusé",
      titleGranted: "Titre attribué",
      toValidate: "À valider",
      internalReferential: "Référentiel interne",
      authorityDocuments: "Documents d'autorité",
      evidenceDossiers: "Dossiers de preuves",
      validationJournal: "Journal de validation",
      documentReceived: "Document reçu",
      documentAccepted: "Document accepté",
      documentRefused: "Document refusé",
      toProvide: "À fournir",
      confidential: "Confidentiel",
      highlyConfidential: "Très confidentiel",
      gradeProof: "Preuve de grade",
      japanProof: "Preuve Japon",
      recommendationLetter: "Lettre de recommandation",
      teachingHistory: "Historique d'enseignement",
      incompleteDossier: "Dossier incomplet",
      readyForDecision: "Prêt pour décision",
      shotokanBlackDragon: "Shotokan Black Dragon",
      overview: "Vue d'ensemble",
      requests: "Demandes",
      authority: "Autorité",
      titlesAndRecognitions: "Titres et reconnaissances",
      documentsAndEvidence: "Documents et preuves",
      documentsPreuves: "Documents & Preuves",
      futureSecurity: "Sécurité future",
      validation: "Validation",
      log: "Journal",
      documentsUnderReview: "Documents en révision",
      secureStorage: "Stockage sécurisé",
      immutableAuditTrail: "Journal immuable",
      sensitivity: "Sensibilité",
      controlledImport: "Import contrôlé",
      previewBeforeImport: "Aperçu avant import",
      confirmLocalImport: "Confirmer import local",
      receivedValidationRequired: "Reçu — validation requise",
      sensitiveDocument: "Document sensible",
      clientImport: "Import client",
      noServerStorage: "Aucun stockage serveur",
      futureSecureBackend: "Backend sécurisé futur",
      immutableAudit: "Audit immuable",
      strictPermissions: "Permissions strictes",
      fileNotOfficiallyStored: "Fichier non stocké officiellement",
      localStorageToBackendMigration: "Migration localStorage vers backend",
      organization: "Organisation",
      dojoActivities: "Activités dojo",
      martialProgression: "Progression martiale",
      administration: "Administration",
      platformManagement: "Gestion plateforme",
      open: "Ouvrir",
      close: "Fermer",
    },
  },
  en: {
    app: {
      login: "Log in",
      logout: "Log out",
      training: "Training",
      help: "Help",
      footerMeta: "Shotokan AAMC",
      switchRole: "Switch profile via Log in",
      placeholderFuture: "Coming in Phase 2+",
      translatePending: "[To translate]",
      classes: "Classes / courses",
      courses: "Courses",
      schedule: "Schedule",
      events: "Events",
      attendance: "Attendance",
      present: "Present",
      absent: "Absent",
      toConfirm: "To confirm",
      notTracked: "Not tracked",
      lightAttendance: "Light attendance",
      progress: "Progress",
      belt: "Belt",
      grade: "Grade",
      exam: "Exam",
      technique: "Technique",
      kata: "Kata",
      kumite: "Kumite",
      discipline: "Discipline",
      admissible: "Eligible",
      recommended: "Recommended",
      toPractice: "To practice",
      mastered: "Mastered",
      toReview: "To review",
      currentBelt: "Current belt",
      nextBelt: "Next belt",
      lightExams: "Light exams",
      titles: "Titles",
      recognitions: "Recognitions",
      titleApplications: "Title applications",
      titleAuthority: "Granting authority",
      appRole: "App role",
      underReview: "Under review",
      missingDocuments: "Missing documents",
      approved: "Approved",
      refused: "Refused",
      titleGranted: "Title granted",
      toValidate: "To validate",
      internalReferential: "Internal referential",
      authorityDocuments: "Authority documents",
      evidenceDossiers: "Evidence dossiers",
      validationJournal: "Validation journal",
      documentReceived: "Document received",
      documentAccepted: "Document accepted",
      documentRefused: "Document refused",
      toProvide: "To provide",
      confidential: "Confidential",
      highlyConfidential: "Highly confidential",
      gradeProof: "Grade proof",
      japanProof: "Japan proof",
      recommendationLetter: "Recommendation letter",
      teachingHistory: "Teaching history",
      incompleteDossier: "Incomplete dossier",
      readyForDecision: "Ready for decision",
      shotokanBlackDragon: "Shotokan Black Dragon",
      overview: "Overview",
      requests: "Requests",
      authority: "Authority",
      titlesAndRecognitions: "Titles and recognitions",
      documentsAndEvidence: "Documents and evidence",
      documentsPreuves: "Documents & Evidence",
      futureSecurity: "Future security",
      validation: "Validation",
      log: "Log",
      documentsUnderReview: "Documents under review",
      secureStorage: "Secure storage",
      immutableAuditTrail: "Immutable audit trail",
      sensitivity: "Sensitivity",
      controlledImport: "Controlled import",
      previewBeforeImport: "Preview before import",
      confirmLocalImport: "Confirm local import",
      receivedValidationRequired: "Received — validation required",
      sensitiveDocument: "Sensitive document",
      clientImport: "Client import",
      noServerStorage: "No server storage",
      futureSecureBackend: "Future secure backend",
      immutableAudit: "Immutable audit",
      strictPermissions: "Strict permissions",
      fileNotOfficiallyStored: "File not officially stored",
      localStorageToBackendMigration: "localStorage to backend migration",
      organization: "Organization",
      dojoActivities: "Dojo activities",
      martialProgression: "Martial progression",
      administration: "Administration",
      platformManagement: "Platform management",
      open: "Open",
      close: "Close",
    },
  },
};

/**
 * @param {(key: string, fallback?: string) => string} t
 * @param {string} key
 * @param {string} frFallback
 */
export function tApp(t, key, frFallback) {
  const val = t(`app.${key}`, frFallback);
  return val || frFallback;
}
